// This file defines the mapping between display paths and actual components
// It will be used to configure React Router

// Import all your page components
import HomePage from "./Components/Header/HomePage";
import AboutPage from "./Components/AboutPage/AboutPage";
import FacultyPage from "./Components/Faculty/FacultyPage";
import FacultyDetailPage from "./Components/Faculty/FacultyDetailPage";
import BscsPage from "./Components/Programs/BscsPage";
import BssePage from "./Components/Programs/BssePage";
import BsArtificialIntelligencePage from "./Components/Programs/Bsai";
import BsCyberSecurityPage from "./Components/Programs/BsCyberSecurityPage";
import MscsPage from "./Components/Programs/MscsPage";
import MsaiPage from "./Components/Programs/MsaiPage";
import ShortCourses from "./Components/Programs/ShortCourses/ShortCourses";
import CampusLife from "./Components/CampusLife/CampusLife";
import CareerPage from "./Components/Career/CareerPage";
import LoginComponent from "./Components/LoginSignup/LoginComponent";
import SignupComponent from "./Components/LoginSignup/SignupComponent";
import PortalLogin from "./Components/Header/PortalLogin";
import AdmissionSchedulePage from "./Components/Header/AdmissionsMenu/AdmissionSchedulePage";
import EligibilityCriteriaPage from "./Components/Header/AdmissionsMenu/EligibilityCriteriaPage";
import FeeStructurePage from "./Components/Header/AdmissionsMenu/FeeStructurePage";
import ScholarshipsPage from "./Components/Header/AdmissionsMenu/ScholarshipsPage";
import MeritCriteriaPage from "./Components/Header/AdmissionsMenu/MeritCriteriaPage";
import AdmissionTestPage from "./Components/Header/AdmissionsMenu/AdmissionTestPage";
import AllTabs from "./Components/LoginSignup/AllTabs";
import ShowStudentForm from "./Components/LoginSignup/ShowStudentForm";
import AdminAllTabs from "./Components/AdminSide/AdminAllTabs";
import VerifyEmail from "./Components/LoginSignup/VerifyEmail";
import ForgotPasswordComponent from "./Components/LoginSignup/ForgotPasswordComponent";
import ResetPasswordComponent from "./Components/LoginSignup/ResetPasswordComponent";
import StudentDashboard from "./Components/AdminSide/StudentTeacherDashboard/StudentDashboard";
import TeacherDashboard from "./Components/AdminSide/StudentTeacherDashboard/TeacherDashboard";
import PortalForgotPassword from "./Components/Header/PortalForgotPassword";
import PortalResetPassword from "./Components/Header/PortalResetPassword";

// Import your private route components
import {
  LoginPrivateRoute,
  StudentPrivateRoute,
} from "./Components/PrivateRoute ";

// Define the route mappings
const routeConfig = [
  // Main routes
  { path: "/", displayPath: "/", component: HomePage },
  {
    path: "/about-us",
    displayPath: "/about-us",
    component: AboutPage,
    originalPath: "/about",
  },
  {
    path: "/our-faculty",
    displayPath: "/our-faculty",
    component: FacultyPage,
    originalPath: "/faculty",
  },
  {
    path: "/our-faculty/:id",
    displayPath: "/our-faculty/:id",
    component: FacultyDetailPage,
    originalPath: "/faculty/:id",
  },

  // Programs routes
  {
    path: "/programs/computer-science",
    displayPath: "/programs/computer-science",
    component: BscsPage,
    originalPath: "/bscs",
  },
  {
    path: "/programs/software-engineering",
    displayPath: "/programs/software-engineering",
    component: BssePage,
    originalPath: "/bsse",
  },
  {
    path: "/programs/artificial-intelligence",
    displayPath: "/programs/artificial-intelligence",
    component: BsArtificialIntelligencePage,
    originalPath: "/bsai",
  },
  {
    path: "/programs/cybersecurity",
    displayPath: "/programs/cybersecurity",
    component: BsCyberSecurityPage,
    originalPath: "/bscys",
  },
  {
    path: "/programs/ms-computer-science",
    displayPath: "/programs/ms-computer-science",
    component: MscsPage,
    originalPath: "/mscs",
  },
  {
    path: "/programs/ms-artificial-intelligence",
    displayPath: "/programs/ms-artificial-intelligence",
    component: MsaiPage,
    originalPath: "/msai",
  },
  {
    path: "/programs/short-courses",
    displayPath: "/programs/short-courses",
    component: ShortCourses,
    originalPath: "/Short-Courses",
  },

  // Admissions routes
  {
    path: "/admissions/schedule",
    displayPath: "/admissions/schedule",
    component: AdmissionSchedulePage,
    originalPath: "/admission-schedule",
  },
  {
    path: "/admissions/eligibility",
    displayPath: "/admissions/eligibility",
    component: EligibilityCriteriaPage,
    originalPath: "/eligibility-criteria",
  },
  {
    path: "/admissions/fees",
    displayPath: "/admissions/fees",
    component: FeeStructurePage,
    originalPath: "/fee-structure",
  },
  {
    path: "/admissions/scholarships",
    displayPath: "/admissions/scholarships",
    component: ScholarshipsPage,
    originalPath: "/scholarships",
  },
  {
    path: "/admissions/merit",
    displayPath: "/admissions/merit",
    component: MeritCriteriaPage,
    originalPath: "/merit-criteria",
  },
  {
    path: "/admissions/test",
    displayPath: "/admissions/test",
    component: AdmissionTestPage,
    originalPath: "/admission-test",
  },

  // Other routes
  {
    path: "/student-life",
    displayPath: "/student-life",
    component: CampusLife,
    originalPath: "/campus",
  },
  {
    path: "/join-us",
    displayPath: "/join-us",
    component: CareerPage,
    originalPath: "/careers",
  },
  {
    path: "/portal-access",
    displayPath: "/portal-access",
    component: PortalLogin,
    originalPath: "/portal",
  },

  // Auth routes
  {
    path: "/sign-in",
    displayPath: "/sign-in",
    component: LoginComponent,
    originalPath: "/login",
  },
  {
    path: "/register",
    displayPath: "/register",
    component: SignupComponent,
    originalPath: "/signup",
  },

  // Private routes
  {
    path: "/application-form",
    displayPath: "/application-form",
    component: <StudentPrivateRoute element={<AllTabs />} />,
    originalPath: "/studentform",
  },
  {
    path: "/admin-dashboard",
    displayPath: "/admin-dashboard",
    component: <LoginPrivateRoute element={<AdminAllTabs />} />,
    originalPath: "/admin",
  },

  // Other routes that don't need masking but should be included
  {
    path: "/ShowStudentForm",
    displayPath: "/ShowStudentForm",
    component: ShowStudentForm,
  },
  {
    path: "/verify-email",
    displayPath: "/verify-email",
    component: VerifyEmail,
  },
  {
    path: "/forgot-password",
    displayPath: "/forgot-password",
    component: ForgotPasswordComponent,
  },
  {
    path: "/reset-password/:token",
    displayPath: "/reset-password/:token",
    component: ResetPasswordComponent,
  },
  {
    path: "/portal/forgot-password",
    displayPath: "/portal/forgot-password",
    component: PortalForgotPassword,
  },
  {
    path: "/portal/reset-password/:token",
    displayPath: "/portal/reset-password/:token",
    component: PortalResetPassword,
  },
  {
    path: "/student-dashboard",
    displayPath: "/student-dashboard",
    component: StudentDashboard,
  },
  {
    path: "/teacher-dashboard",
    displayPath: "/teacher-dashboard",
    component: TeacherDashboard,
  },
];

// Create a mapping for navigation
const navigationMap = {
  // Main navigation items
  main: [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about-us" },
    { name: "Faculty", path: "/our-faculty" },
  ],

  // Programs dropdown
  programs: [
    {
      name: "BS Programs",
      type: "dropdown",
      programs: [
        {
          name: "BSCS",
          path: "/programs/computer-science",
          description: "Computer Science",
        },
        {
          name: "BSSE",
          path: "/programs/software-engineering",
          description: "Software Engineering",
        },
        {
          name: "BSAI",
          path: "/programs/artificial-intelligence",
          description: "Artificial Intelligence",
        },
        {
          name: "BSCYS",
          path: "/programs/cybersecurity",
          description: "Cybersecurity",
        },
      ],
    },
    {
      name: "MS Programs",
      type: "dropdown",
      programs: [
        {
          name: "MSCS",
          path: "/programs/ms-computer-science",
          description: "Computer Science",
        },
        {
          name: "MSAI",
          path: "/programs/ms-artificial-intelligence",
          description: "Artificial Intelligence",
        },
      ],
    },
    {
      name: "Short Courses",
      type: "link",
      path: "/programs/short-courses",
      description: "Professional development courses",
    },
  ],

  // Admissions dropdown
  admissions: [
    { name: "Admission Schedule", path: "/admissions/schedule" },
    { name: "Eligibility Criteria", path: "/admissions/eligibility" },
    { name: "Fee Structure", path: "/admissions/fees" },
    { name: "Scholarships", path: "/admissions/scholarships" },
    { name: "Merit Criteria", path: "/admissions/merit" },
    { name: "NIIT Admission Test", path: "/admissions/test" },
  ],

  // Other navigation items
  other: [
    { name: "Campus Life", path: "/student-life" },
    { name: "Library", path: "https://lib.niit.edu.pk/" },
    { name: "Careers", path: "/join-us" },
    { name: "NIIT Hub", path: "/portal-access" },
  ],

  // Auth links
  auth: [
    { name: "Sign In", path: "/sign-in" },
    { name: "Register", path: "/register" },
    { name: "Apply Now", path: "/sign-in" },
  ],
};

// Helper function to find the original path from a display path
const getOriginalPath = (displayPath) => {
  const route = routeConfig.find((route) => route.path === displayPath);
  return route ? route.originalPath : displayPath;
};

// Helper function to find the display path from an original path
const getDisplayPath = (originalPath) => {
  const route = routeConfig.find(
    (route) => route.originalPath === originalPath
  );
  return route ? route.path : originalPath;
};

export { routeConfig, navigationMap, getOriginalPath, getDisplayPath };
